import { apiClient } from "../client-api";
import { authHeader } from "@/_helpers";
import appConfig from "@/app.config";

export default {
  async login(username, password) {
    const body = { username, password };
    try {
      const response = await apiClient.post(appConfig.jwt_auth, body, {
        headers: authHeader()
      });
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error.response.data);
    }
  },

  async validate() {
    // return authorization header with token token
    let authentication = JSON.parse(localStorage.getItem("authentication"));
    if (authentication && {}.hasOwnProperty.call(authentication, "token")) {
      try {
        const response = await apiClient.post(
          appConfig.jwt_validate,
          { jwt: authentication.token },
          { headers: authHeader() }
        );
        return response;
      } catch (err) {
        throw new Error(err);
      }
    } else {
      throw new Error();
    }
  }
};
